import { computed, signal } from '@preact/signals'
import { useEffect } from 'preact/hooks'
import { detectBreakpoint, on } from 'helpers/dom'
import throttle from 'lodash.throttle'

function appState() {
  const cart = signal(SLS_STATE.cart.initCart)
  const fetching = signal(false)
  const isMobile = signal(detectBreakpoint())

  function setCart(newCart) {
    cart.value = newCart
  }

  function setFetching(status) {
    fetching.value = status
  }

  const hasAgeVerification = computed(() => {
    return cart.value.items.some(item => item.tags.includes('age-verification'))
  })

  useEffect(() => {
    on(
      'resize',
      throttle(() => {
        isMobile.value = detectBreakpoint()
      }, 500),
      window
    )
  }, [])

  return {
    cart,
    setCart,
    fetching,
    setFetching,
    hasAgeVerification,
    isMobile
  }
}

export default appState
